import type {
  AdminInboxDetailVO,
  AdminInboxPageReq,
  AdminInboxPageVO,
  AdminInboxReadVO,
} from '@/types';
import { gatewayRequest } from '@/utils/http';

export const pageAdminInbox = (data: AdminInboxPageReq) =>
  gatewayRequest<AdminInboxPageVO>('/admin/notify/adminInbox/page', {
    method: 'POST',
    data,
  });
export const getAdminInboxDetail = (deliveryId: string) =>
  gatewayRequest<AdminInboxDetailVO>('/admin/notify/adminInbox/detail', {
    method: 'POST',
    data: { deliveryId },
  });
export const markAdminInboxRead = (deliveryId: string) =>
  gatewayRequest<AdminInboxReadVO>('/admin/notify/adminInbox/markRead', {
    method: 'POST',
    data: { deliveryId },
  });
